<app-custom-products-filter-bar></app-custom-products-filter-bar>
<app-custom-products-content ></app-custom-products-content>
